import echo from "@/echo/echo";

let nombreDeCanal = null;

export function suscribirACanalCartelera({
  onSubastasActualizadas,
  onLotesActualizados,
  onDestacadasActualizadas,
} = {}) {
  if (nombreDeCanal) return true;

  nombreDeCanal = "cartelera";

  echo
    .channel(nombreDeCanal)
    .subscribed(() => {
      console.log("[carteleraChannel] conectado");
    })
    .error((error) => {
      console.error("[carteleraChannel] error", error);
    })
    .listen(".CarteleraSubastasActualizadas", (event) => {
      console.log("[carteleraChannel] CarteleraSubastasActualizadas", event);
      onSubastasActualizadas?.(event);
    })
    .listen(".CarteleraLotesActualizados", (event) => {
      console.log("[carteleraChannel] CarteleraLotesActualizados", event);
      onLotesActualizados?.(event);
    })
    .listen(".CarteleraDestacadasActualizadas", (event) => {
      console.log("[carteleraChannel] CarteleraDestacadasActualizadas", event);
      onDestacadasActualizadas?.(event);
    });

  return true;
}

export function abandonarCanalCartelera() {
  if (!nombreDeCanal) return;

  echo.leave(nombreDeCanal);
  nombreDeCanal = null;
}
